export const tr = {
    ad: 'Reklam',
    'ad-description': 'Ayarları yapabileceğiniz yeni reklam oluşturma formu',
    add: 'Ekle',
    campaign: 'Kampanya',
    'campaign-description': 'Reklamların nerede gösterileceği kampanya türüne bağlıdır',
    group: 'Grup',
    'group-limit-description': 'En fazla {limit} yeni reklam oluşturabileceğiniz boş bir reklam grubudur.',
    phrase: 'Anahtar sözcük grupları',
    'phrase-description': 'Gerekli sözcükleri bulmanıza yardımcı olacak anahtar sözcük seçme sihirbazı'
};
